export const crimeVictimFunctions = {
    isDUIorHitAndRun:  (activeCase) => {    
        let flag = false   
    
        if (activeCase) {
    
            // this should activeate only if there is no primary liability
            // if (activeCase?.case.liability_is_dui || activeCase?.case.liability_is_hit_run) { // set tag to true if its true on the case (global items)
            //     flag = true
            // } 

            if (activeCase?.case.liability_is_violent_crime) {
                flag = true
            }


            let primary = activeCase?.liabilities?.find(item => item.is_primary_insurance)

            if (primary) {
                if (primary.dui || primary.hit_run || primary.violent_crime) {
                    flag = true
                } 
                // else {
                //     flag = false
                // }
            } else {
                if (activeCase?.case.liability_is_dui || activeCase?.case.liability_is_hit_run) { // set tag to true if its true on the case (global items)
                    flag = true
                } 
            }
            

            // this will include other liabilities that are not primary
            // let findAnotherItem = activeCase.liabilities.some(item => (item.active && (item.dui || item.hit_run)))
                
            // if (findAnotherItem) {
            //     flag = true
            // } 
        }
    
        return flag
    },

}